import { c as _c } from "react/compiler-runtime";
/**
 * Renders a schema.org JSON-LD block, server-rendered into the initial HTML so
 * crawlers see it without executing JS. This is the one place structured data
 * is serialized — call sites just pass a typed object.
 *
 * Uses the Next.js-recommended pattern (https://nextjs.org/docs/app/guides/json-ld):
 * a plain <script type="application/ld+json"> with the JSON injected as HTML and
 * `<` escaped to `<` to prevent script-injection. `dangerouslySetInnerHTML`
 * is the correct primitive here; keeping it in this single component means it's
 * never repeated or hand-rolled at call sites.
 */
export function JsonLd(t0) {
  const $ = _c(8);
  const {
    id,
    data
  } = t0;
  let t1;
  if ($[0] !== data) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /</g;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = JSON.stringify(data).replace(t2, "\\u003c");
    $[0] = data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = {
      __html: t1
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== id || $[6] !== t2) {
    t3 = <script id={id} type="application/ld+json" dangerouslySetInnerHTML={t2} />;
    $[5] = id;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}